export enum EntityTypeEnum {
    User = 1,
    Client = 2,
    Requisition = 3,
    Account = 4,
    TimeLine = 5,
    Payment = 6,
    Invoice = 7,
    Market = 8,
    UserJob = 9,
    FiniteStateMachine = 10,
    ImportEntity = 11,
    CalendarEvent = 12,
    AIChat = 13,
    Blog = 14,
    DocumentTemplate = 15,
    Other = 99
}